import { Box, CircularProgress } from '@mui/material'
import CardItem from 'components/CardItem'
import TitleWithRoute, { TitleWithRouteType } from 'components/TitleWithRoute'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApiParamsProps, GenericDataType, HouseFavoriteApiService } from 'services'
import ROUTES from 'utils/constants/routesConstant'
import { generateHref } from 'utils/functions'
import { ItemType } from 'utils/types'

const FavoritePlace = () => {
  const { t } = useTranslation('home')
  const history = useHistory()
  const { data, isLoading, refetch } = HouseFavoriteApiService.useGet<GenericDataType<ItemType>>({
    params: {
      page: 1,
      limit: 5,
    } as ApiParamsProps,
  })

  const filteredData = React.useMemo(() => {
    if (data?.data?.result && data?.data?.result?.length) {
      return data?.data?.result
    } else return []
  }, [data])

  return (
    <Box>
      <TitleWithRoute
        buttonText={t('watch_all')}
        href={`${ROUTES.HOUSE_FAVORITE}?page=1`}
        title={
          <>
            <Box className="text-brand-1">{t('place_voted_by_customer')}</Box>
            <Box className="text-stroke">{t('long_time_place_detail', { counter: data?.data?.total })}</Box>
          </>
        }
        type={TitleWithRouteType.TRANSPARENT_BACKGROUND}
      />
      {isLoading ? (
        <Box className="flex justify-center my-8">
          <CircularProgress />
        </Box>
      ) : (
        <Box className="flex flex-wrap gap-5">
          {filteredData.map((item, index) => (
            <CardItem
              id={item._id}
              isPropose
              key={index}
              type={item.type}
              name={item.name}
              image={item?.images?.[0]?.image || ''}
              bathCount={item.n_bathroom}
              bedCount={item.n_bedroom}
              updatedTime={item.updated_at}
              price={item?.sale_price || item?.price}
              type_rental={item.type_rental}
              isLiked={item?.is_favorite}
              onRefetchAfterLike={() => refetch()}
              href={generateHref({ item: item })}
            />
          ))}
        </Box>
      )}
      {!isLoading && !data?.data?.total && (
        <Box className="text-center text-black-1 italic my-8">{t('no_product_exist')}</Box>
      )}
    </Box>
  )
}

export default FavoritePlace
